module.exports = __webpack_public_path__ + "static/media/homepage-hero.41cf0b70.jpg";